export default __webpack_public_path__ + "static/media/alibaba-logo.f5a15518.png";